import type {CreateExtArgs, EnvironmentContext} from '@wix/document-manager-core'
import type {RemoveImagesBackgroundParams} from '@wix/document-services-types'
import {generateAndInjectImages} from './utils'
import {fetchImagesWithNoBackground, type RemoveImageBackgroundParams} from './requests'
import {ERRORS} from '../constants'

export const removeImagesBackground = async (
    {serverFacade}: Pick<EnvironmentContext, 'serverFacade'>,
    createExtArgs: CreateExtArgs,
    {componentPointers, userRequestInfo, onSuccess, onError}: RemoveImagesBackgroundParams
): Promise<void> => {
    return generateAndInjectImages<RemoveImageBackgroundParams>(
        createExtArgs,
        serverFacade,
        componentPointers,
        (_key, url) => ({imageUrl: url}),
        fetchImagesWithNoBackground,
        {
            userRequestInfo,
            onSuccess,
            onError,
            caller: 'removeImagesBackground',
            errorType: ERRORS.IMAGES.REMOVE_IMAGES_BACKGROUND
        }
    )
}
